import React from "react";
import ReactDOM from "react-dom";
import Moment from "react-moment";
import "reflect-metadata";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

Moment.startPooledTimer();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();
